module.exports = __webpack_public_path__ + "media/images/landing/announcement_banner_bg-b82eacdb43b27749de7292d0b7c9472d.png";